export const statusCodes = {
  CONFLICT: 409,
  UNPROCESSABLE_ENTITY: 422,
  INTERNAL_SERVER_ERROR: 500,
  UNAUTHORIZED: 401,
  BAD_REQUEST: 400,
  FORBIDDEN: 403,
};

export const generateRandomString = (myLength) => {
  const chars =
    "AaBbCcDdEeFfGgHhIiJjKkLlMmNnOoPpQqRrSsTtUuVvWwXxYyZz1234567890";
  const randomArray = Array.from(
    { length: myLength },
    (v, k) => chars[Math.floor(Math.random() * chars.length)]
  );

  const randomString = randomArray.join("");
  return randomString;
};

export const isJsonData = (str) => {
  try {
    JSON.parse(str);
    return true;
  } catch (error) {
    return false;
  }
};

export const truncateString = (str, size) => {
  return str.length > size ? str.slice(0, size - 1) + "..." : str;
};

export const formatPermissionStringFromRouteName = (
  permissionAction,
  routeName
) => {
  const arrString = routeName.split("/");
  let permissionString = arrString[arrString.length - 1];
  permissionString = `${permissionAction.toUpperCase()}-${permissionString.toUpperCase()}`;
  return permissionString;
};

export const setLocalAccessToken = (token) => {
  if (token) {
    localStorage.setItem("token", JSON.stringify(token));
  }
};

export const getLocalAccessToken = () => {
  if (isJsonData(localStorage.getItem("token"))) {
    return JSON.parse(localStorage.getItem("token"))
      ? JSON.parse(localStorage.getItem("token"))
      : "";
  }
};

export const setLocalTokenFss = (token) => {
  if (token) {
    localStorage.setItem("tokenFss", JSON.stringify(token));
  }
};

export const getLocalTokenFss = () => {
  if (isJsonData(localStorage.getItem("tokenFss"))) {
    return JSON.parse(localStorage.getItem("tokenFss"))
      ? JSON.parse(localStorage.getItem("tokenFss"))
      : "";
  }
};

export const setLocalRefreshToken = (refreshToken) => {
  if (refreshToken) {
    localStorage.setItem("refreshToken", JSON.stringify(refreshToken));
  }
};

export const getLocalRefreshToken = () => {
  if (isJsonData(localStorage.getItem("refreshToken"))) {
    return JSON.parse(localStorage.getItem("refreshToken"))
      ? JSON.parse(localStorage.getItem("refreshToken"))
      : null;
  }
};

export const setLocalUser = (user) => {
  if (user) {
    localStorage.setItem("user", JSON.stringify(user));
  }
};

export const getLocalUser = () => {
  if (isJsonData(localStorage.getItem("user"))) {
    return JSON.parse(localStorage.getItem("user"))
      ? JSON.parse(localStorage.getItem("user"))
      : {};
  }
};

export const removeLocalUser = () => {
  return localStorage.removeItem("user");
};

export const removeLocalAccessToken = () => {
  return localStorage.removeItem("token");
};

export const removeLocalRefreshToken = () => {
  return localStorage.removeItem("refreshToken");
};

export const setLocalStatusFormLogin = (status) => {
  if (status) {
    localStorage.setItem("statusFormLogin", JSON.stringify(status));
  }
};

export const getLocalStatusFormLogin = () => {
  if (isJsonData(localStorage.getItem("statusFormLogin"))) {
    return JSON.parse(localStorage.getItem("statusFormLogin")) ? true : false;
  }
};

export const clearLocal = () => {
  removeLocalUser();
  removeLocalAccessToken();
  removeLocalRefreshToken();
};

export const compareTwoArrayDnD = (arrayOne, arrayTwo) => {
  return (
    arrayOne.length === arrayTwo.length &&
    arrayOne.every((element, index) => element === arrayTwo[index])
  );
};

export const uuid = () => {
  var temp_url = URL.createObjectURL(new Blob());
  var uuid = temp_url.toString();
  URL.revokeObjectURL(temp_url);
  return uuid.substr(uuid.lastIndexOf("/") + 1);
};

export const currentUserHandleCache = (localUser, currentUserCache) => {
  if (localUser?.id !== currentUserCache?.id) {
    return (
      <span
        style={{ fontWeight: "bold", color: "#fb0b12" }}
      >{`${currentUserCache?.fullName} - ${currentUserCache?.email} `}</span>
    );
  }
  return <span>Bạn </span>;
};
